export default {
  ChartAddEdit: 'ChartAddEdit',
  ChartImport: 'chartImport',
  ChartDelete: 'chartDelete',
  ChartAccountAddEdit: 'chartAccountAddEdit',
  ChartAccountDelete: 'chartAccountDelete',
};
